import { useCallback, useState } from 'react';
import { CommunityId } from '../model/community.types';

type UseCommunityPicker = {
  activeId: CommunityId | null;
  select: (id: CommunityId) => void;
};

export const useCommunityPicker = (ids: CommunityId[]): UseCommunityPicker => {
  const [activeId, setActiveId] = useState<CommunityId | null>(ids[0] ?? null);

  const select = useCallback((id: CommunityId) => setActiveId(id), []);

  return { activeId, select };
};
